"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var BaseXform = require('../base-xform');

var validation = {
  "boolean": function boolean(value, dflt) {
    if (value === undefined) {
      return dflt;
    }

    return value;
  }
}; // Protection encapsulates translation from style.protection model to/from xlsx

var ProtectionXform =
/*#__PURE__*/
function (_BaseXform) {
  _inherits(ProtectionXform, _BaseXform);

  function ProtectionXform() {
    _classCallCheck(this, ProtectionXform);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProtectionXform).apply(this, arguments));
  }

  _createClass(ProtectionXform, [{
    key: "render",
    value: function render(xmlStream, model) {
      xmlStream.addRollback();
      xmlStream.openNode('protection');
      var isValid = false;

      function add(name, value) {
        if (value !== undefined) {
          xmlStream.addAttribute(name, value);
          isValid = true;
        }
      }

      add('locked', validation["boolean"](model.locked, true) ? undefined : '0');
      add('hidden', validation["boolean"](model.hidden, false) ? '1' : undefined);
      xmlStream.closeNode();

      if (isValid) {
        xmlStream.commit();
      } else {
        xmlStream.rollback();
      }
    }
  }, {
    key: "parseOpen",
    value: function parseOpen(node) {
      var model = {
        locked: !(node.attributes.locked === '0'),
        hidden: node.attributes.hidden === '1'
      }; // only want to record models that differ from defaults

      var isSignificant = !model.locked || model.hidden;
      this.model = isSignificant ? model : null;
    }
  }, {
    key: "parseText",
    value: function parseText() {}
  }, {
    key: "parseClose",
    value: function parseClose() {
      return false;
    }
  }, {
    key: "tag",
    get: function get() {
      return 'protection';
    }
  }]);

  return ProtectionXform;
}(BaseXform);

module.exports = ProtectionXform;
//# sourceMappingURL=protection-xform.js.map



//////////////////
// WEBPACK FOOTER
// ./~/exceljs/dist/es5/xlsx/xform/style/protection-xform.js
// module id = 571
// module chunks = 0